import {
  NavDashboardIcon,
  NavCareerIcon,
  NavCareerApplicationsIcon,
  NavProductIcon,
  NavProductListIcon,
  NavProductCategoryIcon,
  NavApplicationIcon,
  NavIndustriesIcon,
  NavAllIndustriesIcon,
  NavPopularProductIcon,
  NavMarketplaceIcon,
  NavLocationsIcon,
  NavDefaultProductsIcon,
  NavSeoIcon,
  NavMediaGroupIcon,
  NavMediaExhibitionIcon,
  NavExhibitionBannerIcon,
  NavBannerImagesIcon,
  NavLeadsIcon,
  NavTalkToExpertIcon,
  NavExportEnquiryIcon,
  NavQuoteRequestIcon,
  NavSampleRequestIcon,
  NavNewsletterIcon,
  NavContentIcon,
  NavContactUsIcon,
  NavFaqIcon,
  NavBlogIcon,
  NavBlogAuthorIcon,
  NavOurTeamIcon,
  NavPrivacyIcon,
  NavTermsIcon,
  NavCookiesIcon,
} from "./navIcons";

const badge = (value) => (value > 0 ? String(value) : undefined);

const navigation = (newLeadCounts = {}) => {
  return [
    { sectionTitle: "Overview" },
    {
      title: "Dashboard",
      icon: NavDashboardIcon,
      path: "/dashboard",
    },
    {
      title: "Career",
      icon: NavCareerIcon,
      children: [
        {
          title: "Job Openings",
          icon: NavCareerIcon,
          path: "/career",
        },
        {
          title: "Applications",
          icon: NavCareerApplicationsIcon,
          path: "/career-applications",
        },
      ],
    },

    { sectionTitle: "Catalog & products" },
    {
      title: "Product",
      icon: NavProductIcon,
      children: [
        {
          title: "Product List",
          icon: NavProductListIcon,
          path: "/products",
        },
        {
          title: "Product Category",
          icon: NavProductCategoryIcon,
          path: "/product-category",
        },
        {
          title: "Application",
          icon: NavApplicationIcon,
          path: "/applications",
        },
      ],
    },
    {
      title: "Industries",
      icon: NavIndustriesIcon,
      children: [
        {
          title: "All Industries",
          icon: NavAllIndustriesIcon,
          path: "/industries",
        },
      ],
    },
    {
      title: "Our Popular Product",
      icon: NavPopularProductIcon,
      path: "/our-popular-product",
    },
    {
      title: "Marketplace",
      icon: NavMarketplaceIcon,
      children: [
        {
          title: "Locations",
          icon: NavLocationsIcon,
          path: "/marketplace-locations",
        },
        {
          title: "Default products",
          icon: NavDefaultProductsIcon,
          path: "/marketplace-default-products",
        },
      ],
    },

    { sectionTitle: "SEO & visibility" },
    {
      title: "Manage SEO",
      icon: NavSeoIcon,
      path: "/seo",
    },

    { sectionTitle: "Media & assets" },
    {
      title: "Media",
      icon: NavMediaGroupIcon,
      children: [
        {
          title: "Media & Exhibition",
          icon: NavMediaExhibitionIcon,
          path: "/media-exhibition-highlights",
        },
        {
          title: "Exhibition Banner Images",
          icon: NavExhibitionBannerIcon,
          path: "/exhibition-banner-images",
        },
      ],
    },
    {
      title: "Banner Images",
      icon: NavBannerImagesIcon,
      path: "/banner-images",
    },

    { sectionTitle: "Leads & CRM" },
    {
      title: "Lead Management",
      icon: NavLeadsIcon,
      children: [
        {
          title: "Talk To Expert",
          icon: NavTalkToExpertIcon,
          path: "/talk-to-expert",
          badgeContent: badge(newLeadCounts.newTalkToExpertCount),
        },
        {
          title: "Export Enquiry",
          icon: NavExportEnquiryIcon,
          path: "/talk-to-export",
          badgeContent: badge(newLeadCounts.newTalkToExportCount),
        },
        {
          title: "Quote Request",
          icon: NavQuoteRequestIcon,
          path: "/quote-request",
          badgeContent: badge(newLeadCounts.newQuoteRequestCount),
        },
        {
          title: "Sample Request",
          icon: NavSampleRequestIcon,
          path: "/sample-request",
          badgeContent: badge(newLeadCounts.newSampleRequestCount),
        },
        {
          title: "Contact Us",
          icon: NavContactUsIcon,
          path: "/contact-us",
          badgeContent: badge(newLeadCounts.newContactUsCount),
        },
        {
          title: "Newsletter Subscribers",
          icon: NavNewsletterIcon,
          path: "/newsletter-subscribers",
        },
      ],
    },

    { sectionTitle: "Content & site" },
    {
      title: "Content Management",
      icon: NavContentIcon,
      children: [
        {
          title: "Faq",
          icon: NavFaqIcon,
          path: "/faq",
        },
        {
          title: "Blogs",
          icon: NavBlogIcon,
          path: "/blog",
        },
        {
          title: "Blog Authors",
          icon: NavBlogAuthorIcon,
          path: "/blog-authors",
        },
        {
          title: "Our Team",
          icon: NavOurTeamIcon,
          path: "/our-team",
        },
        {
          title: "Privacy Policy",
          icon: NavPrivacyIcon,
          path: "/privacy-policy",
        },
        {
          title: "Terms & Conditions",
          icon: NavTermsIcon,
          path: "/terms-conditions",
        },
        {
          title: "Cookies",
          icon: NavCookiesIcon,
          path: "/cookies",
        },
      ],
    },
  ];
};

export default navigation;
